var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CostCalcInfoWritePanel,{attrs:{"costCalcInfoStore":_setup.costCalcInfoStore,"stockCostStore":_setup.stockCostStore}})
}
var staticRenderFns = []

export { render, staticRenderFns }